import { render } from "./Footer.vue?vue&type=template&id=03c0371a&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=03c0371a&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Jude\\Desktop\\projects\\creditclan\\clan\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03c0371a"]])

export default __exports__